export default __webpack_public_path__ + "static/media/female_genital.f6aa284a.png";